import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import classNames from 'classnames';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { getAuthState, getTenantState } from '../../store/selectors';
import {
  setUser,
  setAuthStatus,
  getCurrentUserId,
  getSpecificTenantLogo,
  saveNewTenantForUser,
  saveResults,
} from '../../store/actions';
import CampusBackground from '../CampusBackground';
import BackArrow from '../utility/BackArrow';

require('../../ASUPhotos/backgrounds/campus2.png');

const extraStyles = {
  buttonStyle: (props) => ({
    color: 'white',
    fontSize: '15px',
    backgroundColor: `${props.tenant.primary} !important`,
    '&:hover': {
      backgroundColor: 'white !important',
      border: `2px solid ${props.tenant.primary}`,
      color: props.tenant.primary,
      borderStyle: 'solid',
    },
  }),
  borderSecondary: (props) => ({
    borderBottom: `5px solid ${props.tenant.secondary}`,
  }),
  borderPrimary: (props) => ({
    borderTop: `5px solid ${props.tenant.primary}`,
  }),
};

class LogIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      primaryTenantLogo: null,
    };
  }

  async componentDidMount() {
    const logo = await this.props.getSpecificTenantLogo();

    if (logo && logo.logo && logo.logo.logo) {
      this.setState({
        primaryTenantLogo: logo.logo.logo,
      });
    }
  }

  retryGameWithNewTenant = async () => {
    const userId = await this.props.getCurrentUserId(this.props.auth.jwtToken);

    await this.props.saveNewTenantForUser(userId, this.props.auth.jwtToken);
    this.props.history.push({
      pathname: 'game-landing?retry=true',
    });
  };

  recalculate = async () => {
    const userId = await this.props.getCurrentUserId(this.props.auth.jwtToken);

    this.props.saveNewTenantForUser(userId, this.props.auth.jwtToken);

    const scores = this.props.userData.user;
    const score = {
      riasecValues: {
        r: scores.gameRChoices,
        i: scores.gameIChoices,
        a: scores.gameAChoices,
        s: scores.gameSChoices,
        e: scores.gameEChoices,
        c: scores.gameCChoices,
      },
    };

    await this.props.saveResults(score, this.props.auth.jwtToken);
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <CampusBackground secondaryColor={this.props.tenant.secondary}>
            <div className="login-page multi-login-page">
              <div
                className={classNames({
                  'login-left': true,
                  [this.props.classes.borderPrimary]: true,
                  'multi-login-container': true,
                })}
              >
                <div className="login-text-container">
                  <h1 className="login-header-text">{t('Login')}</h1>
                  <h1 className="login-header-text-mobile">{t('Login')}</h1>
                  <div
                    className={classNames({
                      'header-text-yellow-bar': true,
                      [this.props.classes.borderSecondary]: true,
                    })}
                  />
                </div>
                <div className="main">
                  <div>
                    <p>
                      {t(
                        'We see that you have an existing account with another me3 institution.'
                      )}
                    </p>
                    <p>
                      {t(
                        'Would you like to use your original picture game score?'
                      )}
                    </p>
                  </div>
                  <div className="figures">
                    <div>
                      <img
                        className="tenant-image"
                        src={this.state.primaryTenantLogo}
                        alt="your original tenant Logo"
                      />
                    </div>
                    <div className="arrow">
                      <BackArrow
                        color={this.props.tenant.primary}
                        title="Right arrow"
                      />
                    </div>
                    <div>
                      <img
                        className="tenant-image"
                        src={this.props.tenant.logo}
                        alt={`${this.props.tenant.name} Logo`}
                      />
                    </div>
                  </div>
                  <div className="multi-buttons">
                    <button
                      type="button"
                      className={classNames({
                        'button--primary': true,
                        'login-button': true,
                        [this.props.classes.buttonStyle]: true,
                      })}
                      onClick={() => this.recalculate()}
                      onKeyDown={(e) => {
                        if (['Enter'].includes(e.key)) this.recalculate();
                      }}
                      data-cy="multi-tenant-link-account"
                    >
                      {t('Yes')}
                    </button>
                    <button
                      type="button"
                      className={classNames({
                        'button--primary': true,
                        'login-button': true,
                        [this.props.classes.buttonStyle]: true,
                      })}
                      onClick={() => this.retryGameWithNewTenant()}
                      onKeyDown={(e) => {
                        if (['Enter'].includes(e.key))
                          this.retryGameWithNewTenant();
                      }}
                      data-cy="multi-tenant-new-results"
                    >
                      {t('No')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </CampusBackground>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = (state) => {
  const tenant = getTenantState(state);
  const auth = getAuthState(state);
  const userData = state.onboarding.userData;

  return { auth, tenant, userData };
};

const MultiTenantLogin = withRouter(
  connect(mapStateToProps, {
    setAuthStatus,
    setUser,
    getCurrentUserId,
    getSpecificTenantLogo,
    saveNewTenantForUser,
    saveResults,
  })(LogIn)
);

export default withStyles(extraStyles)(MultiTenantLogin);
